import { fb } from '../firebase'

type Params = Parameters<ReturnType<typeof fb.call<'generateOgpImage'>>>[0]

/**
 * OGP 画像を公開（作成・更新）の前に生成する
 * 画像が先に存在するので、公開直後に SNS に共有してもクローラが 404 を引かない
 * 失敗したら公開を中断する（画像なしで公開されたまま気づけない状態を作らない）
 */
export const prepareOgpImage = async (params: Params) => {
  try {
    await fb.call('generateOgpImage')(params)
  } catch (error) {
    console.error(error)
    throw new Error(
      'OGP画像の生成に失敗しました。時間をおいてもう一度お試しください。'
    )
  }
}
